//@ts-ignore
import { addQuery, getQuery } from '@mindtickle/utils/url';
import { isEmpty } from '../../../../utils';
export var appendQueryName = function () { return function (next) { return function (req) {
    try {
        var url = req.fetchOpts.url;
        if (url && 'id' in req && isEmpty(getQuery(url, ['name']))) {
            req.fetchOpts.url = addQuery(url, { name: req === null || req === void 0 ? void 0 : req.id });
        }
        return next(req);
    }
    catch (err) {
        console.error(err); // eslint-disable-line
        return next(req);
    }
}; }; };
//# sourceMappingURL=appendQueryName.js.map